import React from "react";

import cx from "classnames";

import { Button } from "~/ui";

import styles from "./RedactingTranscriptHeader.module.css";

interface RedactingTranscriptHeaderProps {
	exitRedactionMode: () => void;
	saveRedaction: () => void;
	readyToSave: boolean;
}

export default function RedactingTranscriptHeader({
	exitRedactionMode,
	readyToSave,
	saveRedaction,
}: RedactingTranscriptHeaderProps) {
	return (
		<div className={cx(styles.header, { [styles.ready]: readyToSave })}>
			<strong>{readyToSave ? "Permanently redact content?" : "Select content to be redacted"}</strong>
			<Button size="slim" variant="secondary" onClick={exitRedactionMode}>
				Exit
			</Button>
			<Button size="slim" variant="destructive" disabled={!readyToSave} onClick={saveRedaction}>
				Redact
			</Button>
		</div>
	);
}
